import { Component, Inject } from '@angular/core';
import { DirtyComponent } from '../../../helpers/CanDeactivate/dirty-component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { FormBuilder, Validators } from '@angular/forms';
import { AttendanceService } from '../../../features/HR-Manager/attendance-list/services/attendance.service';
import Swal from 'sweetalert2';
import { DatePipe } from '@angular/common';

// interface DialogData {
//   id: string
//   time_in: string
//   time_out: string
//   over_time_seconds: number
//   minus_time_seconds: number
//   has_request: boolean
//   is_request_approved: boolean
//   type_request_enum: boolean
//   check_in_inside_company: number
//   check_out_inside_company: number
//   reason_correct_sign_in: string
//   is_correct_sign_in_by_admin: number
//   reason_correct_sign_out: string
//   is_correct_sign_out_by_admin: number
//   type: string
// }


export interface DialogData {
  id: string,
  type: string
  index: number
  history: {
    id: string
    time_in: string
    time_out: string
  }[]
}

@Component({
  selector: 'app-update-attendance',
  templateUrl: './update-attendance.component.html',
  styles: ``
})
export class UpdateAttendanceComponent extends DirtyComponent {
  loading: boolean = false;
  constructor(
    override dialogRef: MatDialogRef<UpdateAttendanceComponent>,
    translate: TranslateService,
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private service: AttendanceService,
    private datePipe: DatePipe
  ) {
    super(translate);
  }

  ngOnInit(): void {
    this.buildForm();
  }

  saveRecord() {
    if (this.formGroup.valid) {
      this.loading = true;
      let model = this.formGroup.value;
      model.time = this.convertTime(model.time);
      this.service.updateAttendace(model).subscribe({
        next: (response) => {
          this.loading = false;
          this.dialogRef.close(model);
          Swal.fire({
            title: this.data.type == 'check-in' ? this.translate.instant("hrService.attendanceTimeUpdatedSuccessfully") : this.translate.instant("hrService.departureTimeUpdatedSuccessfully"),
            text: '',
            imageUrl: './assets/images/icons/success.svg',
            confirmButtonText: this.translate.instant('swalMsg.Ok')
          });
        },
        error: (error) => {
          this.loading = false;
        }
      })
    }

  }
  buildForm() {
    this.formGroup = this.formBuilder.group({
      reason: ['', []],
      time: ['', [Validators.required]],
      attendance_id: [this.data.history[this.data.index].id, [Validators.required]],
      type: [this.data.type, [Validators.required]],
    });
  }

  formatTime(date: Date | string) {
    return new Date(date).toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })
  }

  convertTime(timeStr: any) {
    // Split the input into time and period (AM/PM)
    const [timePart, period] = timeStr.split(' ');
    let [hours, minutes] = timePart.split(':').map(Number);

    if (period === 'AM' || period === 'ص') {
      if (hours === 12) {
        hours = 0; // Midnight case
      }
    } else if (period === 'PM' || period === 'م') {
      if (hours !== 12) {
        hours += 12; // PM case (except 12 PM)
      }
    }
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  };

  resetTimeValue() {
    return this.formGroup.controls['time'].setValue('');
  }

  get MaxTime(): string {
    let isToday = new Date(this.data.history[this.data.index].time_in).setHours(0, 0, 0, 0) == new Date(Date.now()).setHours(0, 0, 0, 0);
    let max
    if (this.data.index == this.data.history.length - 1 && this.data.type == "check-out") {
      return isToday ? this.formatTime(new Date(Date.now())) : '23:59 PM';
    } else if (this.data.type == "check-out") {
      return (isToday && !this.data?.history[this.data.index + 1]?.time_in) ? this.formatTime(new Date(Date.now())) : (this.data.history[this.data.index + 1] ? this.formatTime(this.data.history[this.data.index + 1].time_in) : '23:59 PM');
    } else if (this.data.type == "check-in") {
      return (isToday && !this.data?.history[this.data.index]?.time_out) ? this.formatTime(new Date(Date.now())) : (this.data.history[this.data.index].time_out ? this.formatTime(this.data.history[this.data.index].time_out) : '23:59 PM');
    } else {
      return '23:59 PM';
    }
  }

  get MinTime(): string {
    if (this.data.index == 0 && this.data.type == "check-in") {
      return '00:00 AM';
    } else if (this.data.type == "check-out") {
      return this.formatTime(this.data.history[this.data.index].time_in);
    } else if (this.data.type == "check-in") {
      return this.formatTime(this.data.history[this.data.index - 1].time_out);
    } else {
      return '00:00 AM';
    }
  }
  hasError(controlName: string, errorName: string) {
    return this.formGroup.controls[controlName].hasError(errorName);
  }
}
